export enum CargoTypeEnum {
    CardboardBox = 0,
    EuroPallet = 1,
    PalletFin = 2,
    PalletInd = 3,
    Other = 4
}